<template>
  <div class="ma-0">
    <iframe
      :src="editorUrl"
      ref="iframe"
      width="100%"
      scrolling="no"
      style="min-height: calc(100vh)"
    ></iframe>
    <MetaInfo />
    <TypeInfo />
    <EditorModelChoose :courseId="courseId" @finish="refreshModelList" />
  </div>
</template>

<script>
import MetaInfo from './Editor/MetaInfo.vue';
import TypeInfo from './Editor/TypeInfo.vue';
import EditorModelChoose from './Editor/EditorModelChoose.vue';
import { mapGetters } from 'vuex';
export default {
  components: {
    MetaInfo,
    TypeInfo,
    EditorModelChoose,
  },
  computed: {
    ...mapGetters(['showDefinition']),
    editorUrl() {
      return `${process.env.VUE_APP_3D_EDITOR_URL}#/?id=1&edt_id=${this.editor_id}&course=${this.courseId}&token=${this.token}`;
    },
  },
  data() {
    return {
      iframeWin: {},
      editor_id: '',
      courseId: '',
      tab: null,
      token: '',
    };
  },
  mounted() {
    this.editor_id = this.$route.params.editorId;
    this.courseId = this.$route.params.courseId;
    this.token = this.$route.params.token;
    this.$store.dispatch('editorDefinition/loadData', this.editor_id);
    this.iframeWin = this.$refs.iframe.contentWindow;
    window.addEventListener('message', this.handleMessage, false);
  },
  beforeDestroy() {
    window.removeEventListener('message', this.listenerPostMessage, false);
  },
  methods: {
    refreshModelList() {
      this.iframeWin.postMessage(JSON.stringify({ cmd: 'refreshModelList' }), '*');
    },
    handleMessage(event) {
      if (!event.data) return;

      // 选择模型
      if (event.data.cmd === 'chooseModel') {
        // 打开模型选择弹窗
        this.$store.dispatch('editor/reverseShowOpenModelChoose', true);
        this.$store.dispatch('editor/setEditorChooseModelArr', JSON.parse(event.data.data));
        return;
      }
      if (event.data.cmd === 'backLastPage') {
        this.$router.push({ name: 'design' });
        return;
      }

      if (!event.data.nodeTreeData) return;

      const data = JSON.parse(event.data.nodeTreeData);
      if (data) {
        this.$store.dispatch('editorDefinition/reverseDefinitionStatus', true);

        // const obj = this.iframeWin.viewer.modelGroup.getObjectById(data.id)

        // const getNameFunc = (obj, arr = []) => {
        //   if (!obj.parent || obj.name === 'modelGroup') {
        //     return obj.viewer.curModelName
        //   }

        //   if (obj.name !== 'RootNode') {
        //     arr.push(obj.alias ?? obj.name)
        //   }
        //   return getNameFunc(obj.parent, arr)
        // }
        this.$store.dispatch('editorDefinition/checkStruct', {
          structId: data.structId,
          modelName: data.name,
        });

        this.$store.dispatch('editorType/loadData', this.courseId);
      }
    },
  },
};
</script>

<style>
.btn {
  width: 100px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  border: 1px solid #ccc;
  border-radius: 12px;
  position: fixed;
  top: 0;
  left: 0;
}

.iframeClass {
  width: 100%;
  height: 100vh;
}
</style>
